import Grid from './grid.vue';
import GridItem from './grid-item.vue';

Grid.Item = GridItem;
export default Grid;


// WEBPACK FOOTER //
// ./src/components/grid/index.js